import _ from 'lodash'
window._ = _
import './scripts/scripts';

document.addEventListener('DOMContentLoaded', () => {
	// console.log(Swiper);
});